type ClipboardItemLike = {
   kind: string;
   type: string;
   getAsFile: () => File | null;
};

export type ClipboardDataLike = {
   files?: ArrayLike<File> | null;
   items?: ArrayLike<ClipboardItemLike> | null;
   getData?: (format: string) => string;
};

const fileIdentity = (file: File): string => `${file.name}:${file.size}:${file.type}`;

const isImageFile = (file: File): boolean => file.type.startsWith("image/");

/**
 * Collect image files from a paste event. Screenshots often appear on both
 * `files` and `items`; we read both and de-dupe.
 */
export const getImageFilesFromClipboard = (
   clipboardData: ClipboardDataLike | null | undefined
): File[] => {
   if (!clipboardData) return [];

   const images: File[] = [];
   const seen = new Set<string>();

   const addIfImage = (file: File | null) => {
      if (!file || !isImageFile(file)) return;
      const id = fileIdentity(file);
      if (seen.has(id)) return;
      seen.add(id);
      images.push(file);
   };

   if (clipboardData.files) {
      Array.from(clipboardData.files).forEach(addIfImage);
   }

   if (clipboardData.items) {
      Array.from(clipboardData.items).forEach((item) => {
         if (item.kind === "file") addIfImage(item.getAsFile());
      });
   }

   return images;
};

export const clipboardHasPlainText = (
   clipboardData: ClipboardDataLike | null | undefined
): boolean => {
   if (!clipboardData?.getData) return false;
   return clipboardData.getData("text/plain").trim().length > 0;
};
